import React from "react";
import { useClock } from "../hooks/useClock";
import VolumeBadge from "./VolumeBadge";

// Tijd en datum in de topbar, met het volumebalkje als dat net veranderd is.
const TopbarClock = () => {
  const { hours, minutes, date } = useClock();

  return (
    <div className="topbar-clock">
      <span className="tc-time">
        {hours}:{minutes}
      </span>
      <span className="tc-date">{date}</span>
      <VolumeBadge />
    </div>
  );
};

export default TopbarClock;
